import React from 'react';

import { MessageItem, MessageItemInputProps } from './message-item';

type InputProps = Omit<
  MessageItemInputProps,
  | 'isAnnouncementThread'
  | 'hideHeaderActions'
  | 'isPreview'
  | 'onEditMessage'
  | 'onCancelMessage'
  | 'onDeleteMessage'
  | 'announcementGroupLabelOnClick'
>;

export const MessagePreviewItem = (props: InputProps) => (
  <MessageItem {...props} hideHeaderActions isPreview />
);
